import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {PageContent} from "../Layout";
import {Button, Col, Row} from "reactstrap";
import {api} from "../../api";
import {IWindow} from "../../index";
import {DropZoneStore} from "../../stores/DropZoneStore";
import DropZone from "../../stores/DropZoneStore";

const IWindow: IWindow = (window as IWindow);

export class ImportRegionFormData {
    @observable fileId = {};

}

export class ImportRegionForm extends CrudForm {
    modelName = 'ImportRegion';
    @observable showSubmitButton = false;
    @observable file_uploaded = false;
    @observable is_imported: number | null = null;

    icon = '';
    statusInterval: any = null;

    uploadData = async () => {
        await api.import.postFormAction('', {
            'upload_id': this.formStore.getValue('fileId')
        }).then((data: any) => {
            this.id = data.id;
            this.is_imported = 1;
            this.statusInterval = setInterval(this.updateImportStatus, 5000);
        });
        this.isLoading = false;
    };

    updateImportStatus = async () => {
        this.is_imported !== 2 ?
        await api.import.getDetailAction(this.id).then((data: any) => {
            if (data.is_imported) {
                this.is_imported = 2;
                clearInterval(this.statusInterval);
                setTimeout(window.location.reload(), 5000);
            }
        }) : '';
    };

    dropZoneStore = new DropZoneStore();

    djsConfig = {
        maxFilesize: 100,
        paramName: "file_upload",
        params: {
            file_field: 'import_document',
        }
    };

    componentConfig = {
        postUrl: 'upload',
    };

    eventHandlers = {
        error: (file: any, response: any) => {
            console.log(file);
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
        },
        success: (file: any, response: any) => {
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
            this.file_uploaded = true;
            this.formStore.setValue('fileId', response.upload_id);
        },
    };

    onClickButton(event: any) {
        event.preventDefault();
    };


    renderFields() {
        let importStatusClass =  this.is_imported === 2  ? 'alert-success' : 'alert-warning';
        return (
            <>
                {
                    this.file_uploaded && !this.is_imported ?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    File uploaded successfully
                                </div>
                            </Col>
                        </Row> : ''
                }

                {
                    this.file_uploaded && this.is_imported ?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className={ "alert alert-dismissible fade show " + importStatusClass } role="alert">

                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {this.is_imported === 2 ? 'File import data completed' : 'File import data in progress'}
                                </div>
                            </Col>
                        </Row> : ''
                }
                <Row className="form-row">
                    <Col md={6} className={'d-flex'}>
                        {!this.is_imported ?
                        <DropZone
                            store={this.dropZoneStore}
                            componentConfig={this.componentConfig}
                            djsConfig={this.djsConfig}
                            eventHandlers={this.eventHandlers}
                        >
                            <Button className="image-uploader" onClick={this.onClickButton}>
                                Click to Select Data File
                            </Button>
                            <div
                                className="form-progress-bar"
                                style={{width: `${this.dropZoneStore.progress}%`}}
                            />
                        </DropZone> : ''}

                        {this.file_uploaded && !this.is_imported ?
                            <Button onClick={this.uploadData} type="button" color="primary" className={'mb-3 ml-2'}>
                                Start Importing Data
                            </Button> : ''
                        }
                    </Col>
                </Row>
            </>
        );
    }
}

export class ImportRegionPage extends React.Component {
    modelName = 'ImportRegion';

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <>
                <PageContent>
                    <ImportRegionForm/>
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ImportRegionPage.tsx